module.exports = __webpack_public_path__ + "static/media/step-big-full.7b02e6db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-big-full.svg
// module id = 854
// module chunks = 21